import { useTranslation } from "react-i18next"
import { Button } from "@nexus/ui"

import type { PersonasOnboardingCardVariant } from "./persona-onboarding-card.types"

export function RejectedBar({
  onUndo,
  isBusy,
  variant,
}: {
  onUndo?: () => void
  isBusy: boolean
  variant: PersonasOnboardingCardVariant
}) {
  const { t } = useTranslation()
  const isIndustry = variant === "industry"
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-1 py-1">
      <p className="text-xs text-muted-foreground">
        {t(
          isIndustry
            ? "personas.onboarding.industry.rejectedFooter"
            : "personas.onboarding.review.rejectedFooter",
          "Rejected — its ads return to the unmapped pool",
        )}
      </p>
      {onUndo && (
        <Button type="button" variant="secondary" size="sm" disabled={isBusy} onClick={onUndo}>
          {t(
            isIndustry
              ? "personas.onboarding.industry.reconsider"
              : "personas.onboarding.review.reconsider",
            "Reconsider",
          )}
        </Button>
      )}
    </div>
  )
}
